import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'

const resource = `${Config.basePath}/upload/file`

export default {
  upload(formData) {
    return Client.post(resource, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
